/*
 * Longeva PDP accordion — smooth height transitions on native <details>.
 *
 * Mirrors the reference theme's <details-disclosure> pattern: animate the panel height
 * between 0 and auto using a measured-then-released technique. Pure
 * vanilla, no library. Respects prefers-reduced-motion.
 */

(() => {
  "use strict";

  const REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const ANIM_MS = 320;

  const setupAccordions = () => {
    document.querySelectorAll(".longeva-pdp-disclosure").forEach((details) => {
      if (details.dataset.longevaWired === "1") return;
      details.dataset.longevaWired = "1";

      const panel = details.querySelector(".longeva-pdp-disclosure__panel");
      if (!panel) return;

      // Make sure closed state has 0 height; open state has natural height.
      if (!details.open) panel.style.height = "0px";
      else panel.style.height = "auto";

      const summary = details.querySelector(".longeva-pdp-disclosure__summary");
      if (!summary) return;

      summary.addEventListener("click", (e) => {
        if (REDUCED) return; // let native behaviour fire
        e.preventDefault();

        const isOpen = details.open;
        const startHeight = panel.getBoundingClientRect().height;

        if (isOpen) {
          // Closing
          panel.style.height = startHeight + "px";
          // force reflow
          void panel.offsetHeight;
          panel.style.height = "0px";
          details.classList.add("is-closing");
          const onEnd = (evt) => {
            if (evt.propertyName !== "height") return;
            panel.removeEventListener("transitionend", onEnd);
            details.open = false;
            details.classList.remove("is-closing");
          };
          panel.addEventListener("transitionend", onEnd);
        } else {
          // Opening
          details.open = true;
          // Measure target height
          panel.style.height = "auto";
          const targetHeight = panel.getBoundingClientRect().height;
          panel.style.height = "0px";
          void panel.offsetHeight;
          panel.style.height = targetHeight + "px";
          const onEnd = (evt) => {
            if (evt.propertyName !== "height") return;
            panel.removeEventListener("transitionend", onEnd);
            panel.style.height = "auto";
          };
          panel.addEventListener("transitionend", onEnd);
        }
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupAccordions, { once: true });
  } else {
    setupAccordions();
  }
  // Re-scan when DOM mutates (Horizon may re-render sections)
  setTimeout(setupAccordions, 400);
  setTimeout(setupAccordions, 1500);
})();
